<template>
  <div>
    <page-title id="pageTitle">{{pageHeader}}</page-title>
    <div class="steps" id="stepsDemo">
      <div class="step-item is-active is-success">
        <div class="step-marker">1</div>
        <div class="step-details">
          <p class="step-title">Shipper & Consignee Details</p>
        </div>
      </div>
      <div class="step-item">
        <div class="step-marker">2</div>
        <div class="step-details">
          <p class="step-title">DG Details</p>
        </div>
      </div>
      <div class="step-item">
        <div class="step-marker">3</div>
        <div class="step-details">
          <p class="step-title">Additional Information & Docs</p>
        </div>
      </div>
      <div class="step-item">
        <div class="step-marker">4</div>
        <div class="step-details">
          <p class="step-title">Application Summary</p>
        </div>
      </div>
      <div class="step-item">
        <div class="step-marker">5</div>
        <div class="step-details">
          <p class="step-title">Confirmation</p>
        </div>
      </div>

      <div class="has-margin-top-60 is-full-width" v-if="formReferenceNumber">
        <h3 class="has-text-weight-bold is-size-5">
          Form Reference Number:
          <span class="is-uppercase">{{ formReferenceNumber }}</span>
        </h3>
      </div>

      <!-- Steps Content -->
      <div class="steps-content">
        <!-- Shipper Consignee Details -->
        <div class="step-content is-active">
          <shipper-consignee-details
            :shipper-consignee-details="shipperConsigneeDetails"
            :move-to-previous="previousInForm"
            :move-to-next="nextInForm"
            :ports="ports.data"
          ></shipper-consignee-details>
        </div>

        <!-- DG Details -->
        <div class="step-content">
          <dangerous-goods-details
            :dangerous-goods="dangerousGoods"
            :move-to-previous="previousInForm"
            :move-to-next="nextInForm"
            :save-shipping-request="onSave"
          ></dangerous-goods-details>
        </div>

        <!-- Additional Info and DOcs -->
        <div class="step-content">
          <additional-info-and-docs
            :additionalInfoAndDocs="additionalInfoAndDocs"
            :move-to-previous="previousInForm"
            :move-to-next="nextInForm"
            :save-shipping-request="onSave"
            :certificate-documents="certificateDocuments"
            :uploaded-documents="uploadedDocuments"
          ></additional-info-and-docs>
        </div>

        <!-- Additional Details -->
        <div class="step-content">
          <application-summary :move-to-previous="previousInForm" :move-to-next="nextInForm"></application-summary>
        </div>

        <!-- Confirmation -->
        <div class="step-content">
          <confirmation
            :move-to-previous="previousInForm"
            :submit-shipping-request="onSubmit"
            :shipper-declaration="shipperDeclaration"
          ></confirmation>
        </div>
      </div>

      <!-- Form Buttons -->
      <div class="steps-actions d-none">
        <div class="steps-action">
          <a href="#" ref="previousButton" data-nav="previous" class="button is-danger">Previous</a>
        </div>

        <div class="steps-action">
          <a href="#" ref="nextButton" data-nav="next" class="button is-primary">Next</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import bulmaSteps from "bulma-steps/dist/js/bulma-steps.min.js";
import ShipperConsigneeDetails from "./ShipperAndConsigneeDetails";
import DangerousGoodsDetails from "./DangerousGoodsDetails";
import AdditionalInfoAndDocs from "./AdditionalInfoAndDocs";
import ApplicationSummary from "./ApplicationSummary";
import Confirmation from "./Confirmation";

import { SHIPPER_MUTATION_TYPES } from "@/store/mutation-types";
import { createNamespacedHelpers } from "vuex";
const { mapMutations, mapGetters } = createNamespacedHelpers("shippers");
import { mapGetters as mapRootGetters } from "vuex";
import { setTimeout } from "timers";

export default {
  name: "ShippingRequest",

  components: {
    ShipperConsigneeDetails,
    DangerousGoodsDetails,
    AdditionalInfoAndDocs,
    ApplicationSummary,
    Confirmation
  },

  props: {
    pageHeader: { type: String, default: "DG Shipping Application" },
    onSave: { type: Function, required: true },
    onSubmit: { type: Function, required: true },
    canSave: { type: Boolean, default: false }
  },


  mounted: function() {
    // For Stepper Form
    bulmaSteps.attach("#stepsDemo");
  },

  computed: {
    ...mapGetters({
      shipperConsigneeDetails: "getShipperAndConsigneeDetails",
      dangerousGoods: "getDangerousGoods",
      additionalInfoAndDocs: "getAdditionalInfoAndDocs",
      certificateDocuments: "getCertificateDocuments",
      uploadedDocuments: "getUploadedDocuments",
      shipperDeclaration: "getShipperDeclaration",
      formReferenceNumber: "getFormReferenceNumber"
    }),
    ...mapRootGetters({
      ports: "getPorts"
    })
  },

  methods: {
    // Move to the next step in the multistepform
    nextInForm: function() {
      this.$refs.nextButton.click();

      setTimeout(() => {
        // Scroll to the top of the page when user clicks next
        document.getElementById("pageTitle").scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest"
        });
      }, 200);
    },

    // Move to the previous step in the multistepform
    previousInForm: function() {
      this.$refs.previousButton.click();

      setTimeout(() => {
        // Scroll to the top of the page when user clicks previous
        document.getElementById("pageTitle").scrollIntoView({
          behavior: "smooth",
          block: "start",
          inline: "nearest"
        });
      }, 200);
    }
  }
};
</script>

<style lang="scss" scoped>
.border-bottom {
  border-bottom: 1px solid #ddd;
}
.d-none {
  display: none !important;
}
</style>
